<template>
  <div class="webgl-content">
    <unity id="unityContainer" :hideFooter="true" :src="unity.json" width="100%" height="100%" :unityLoader="unity.loader" ref="unity"></unity>
    <div class="footer">
      <div class="webgl-logo"></div>
      <div class="fullscreen" @click="setFullscreen"></div>
      <div class="title">Ação de um campo elétrico</div>
    </div>
  </div>
</template>

<script>
import Unity from 'vue-unity-webgl'
import '../../../../../public/unity/TemplateData/style.css'

export default {
  name: 'TopicoLabVirtual',
  props: {
    ementaCurso: {
      type: Object,
      required: true
    }
  },
  components: { Unity },
  data () {
    return {
      unity: {
        json: `${process.env.VUE_APP_BASE_FILES_URL}${this.ementaCurso.topico_escolhido.s3_url}/${this.ementaCurso.topico_escolhido.url}/${this.ementaCurso.topico_escolhido.config_json}`,
        loader: `${process.env.VUE_APP_BASE_FILES_URL}${this.ementaCurso.topico_escolhido.s3_url}/${this.ementaCurso.topico_escolhido.url}/UnityLoader.js`
      }
    }
  },
  methods: {
    setFullscreen: function () {
      this.$refs.unity.fullscreen()
    }
  }
}
</script>
